import { SettingsType } from "building-types/settings/settingsType";
import { arrayFlatten } from "common/utils/arrays";
import type { EntityTypesEligibleForEntitySettings } from "./entitySettingsTypes";

export const docEntityTypeToEligibleTargetedSettingsType: {
  [key in EntityTypesEligibleForEntitySettings]: SettingsType[];
} = {
  DORMER: [
    SettingsType.WINDOW_SETTINGS,
    SettingsType.WINDOW_MATERIAL_SETTINGS,
    SettingsType.EXTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_SHUTTER_SETTINGS,
    SettingsType.AWNING_SETTINGS,
    SettingsType.WINDOW_FRAMING_SETTINGS,
    SettingsType.INTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_MULLION_SETTINGS,
    SettingsType.DORMER_SETTINGS,
  ],
  FLOOR: [SettingsType.FLOOR_SETTINGS],
  FOUNDATION: [SettingsType.FOUNDATION_SETTINGS],
  OPENING: [
    SettingsType.WINDOW_SETTINGS,
    SettingsType.WINDOW_WRAPPING_SETTINGS,
    SettingsType.WINDOW_MATERIAL_SETTINGS,
    SettingsType.DOOR_SETTINGS,
    SettingsType.DOOR_WRAPPING_SETTINGS,
    SettingsType.EXTERIOR_DOOR_CASING_SETTINGS,
    SettingsType.INTERIOR_DOOR_CASING_SETTINGS,
    SettingsType.EXTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_SHUTTER_SETTINGS,
    SettingsType.AWNING_SETTINGS,
    SettingsType.WINDOW_FRAMING_SETTINGS,
    SettingsType.WINDOW_WRAPPING_SETTINGS,
    SettingsType.DOOR_FRAMING_SETTINGS,
    SettingsType.INTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_MULLION_SETTINGS,
  ],
  ROOF: [SettingsType.ROOF_SETTINGS],
  ROOF_OPENING: [
    SettingsType.WINDOW_SETTINGS,
    SettingsType.WINDOW_MATERIAL_SETTINGS,
    SettingsType.EXTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_SHUTTER_SETTINGS,
    SettingsType.AWNING_SETTINGS,
    SettingsType.WINDOW_FRAMING_SETTINGS,
    SettingsType.INTERIOR_WINDOW_CASING_SETTINGS,
    SettingsType.WINDOW_MULLION_SETTINGS,
  ],
  ROOM: [SettingsType.PORCH_SETTINGS, SettingsType.REAR_PORCH_SETTINGS],
};

export const docEntityTypeToEligibleSettingsTypeUnique = (() => {
  const types = arrayFlatten<SettingsType>(Object.values(docEntityTypeToEligibleTargetedSettingsType));
  return Array.from(new Set(types));
})();
